import moment from "moment";

export function dateFormat(time) {
  moment.locale("zh-cn");
  var datetime = time;
  time = moment(datetime).format('YYYY-MM-DD HH:mm:ss');
  return time;
}

export function dateFormatHMS(time) {
  moment.locale("zh-cn");
  var datetime = time;
  time = moment(datetime).format('HH:mm:ss');
  return time;
}

export function dayFormat(time) {
  if (time) {
    moment.locale("zh-cn");
    var datetime = time;
    time = moment(datetime).format('YYYY-MM-DD');
    return time;
  } else {
    return "—"
  }
}

export function monthFormat(time) {
  if (time) {
    moment.locale("zh-cn");
    var datetime = time;
    time = moment(datetime).format('YYYY-MM');
    return time;
  } else {
    return "—"
  }
}

export function dateFormatChinese(time) {
  moment.locale("zh-cn");
  var datetime = time;
  time = moment(datetime).format('YYYY[年]MM[月]DD[日]');
  return time;
}

export function dateFormatYMD(time) {
  moment.locale("zh-cn");
  var datetime = time;
  if (!time && typeof time!="undefined" && time!=0) {
    return '—'
  }else{
    time = moment(datetime).format('YYYY-MM-DD');
    return time;
  }
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function htmlLength(val, length) {
  if (val && val.length > length) {
    return val.replace(/<\/?.+?>/g, "").slice(0, length) + '...';
  } else if (val && val.length <= length) {
    return val.replace(/<\/?.+?>/g, "")
  } else if (val == null || val == '') {
    return '—'
  }
}
export function typeKey(key) {
  if (key === 'UserAdmin') {
    return '全部类型'
  }
  if (key === 'User') {
    return '网站用户'
  }
  if (key === 'Admin') {
    return '后台用户'
  }
}

export function timeAgo(time) {
  if (time) {
    var beginTime = new Date(time.replace(/-/g, "/"))
    var dateDiff = new Date().getTime() - beginTime.getTime();//时间差的毫秒数
    if (Math.floor(dateDiff / (60 * 1000)) < 60) {
      if (Math.floor(dateDiff / (60 * 1000)) < 1) {
        dateDiff = '1分钟内'
      } else {
        dateDiff = Math.floor(dateDiff / (60 * 1000)) + '分钟前'
      }
    } else if (Math.floor(dateDiff / (60 * 1000 * 60)) < 24) {
      dateDiff = Math.floor(dateDiff / (60 * 1000 * 60)) + '小时前'
    } else if (Math.floor(dateDiff / (60 * 1000 * 60)) < 48) {
      dateDiff = Math.floor(dateDiff / (60 * 1000 * 60 * 24)) + '天前'
    } else {
      dateDiff = time.split(' ')[0]
    }
    return dateDiff
  }else{
    return '—'
  }
}
/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function basicFields(val) {
  let arr=[];
  val.map(item=>{
    arr.push(item.option)
  });
  return arr.join('、')
}

export function nullValue(val) {
  if ((val == null || val == '') && val !== 0) {
    return '—'
  }
  return val;
}

export function nullTableValue(val) {
  if ((val == null || val == '') && val !== 0) {
    return '-'
  }
  return val;
}

export function filterTryDays(val) {
  if ((val == null || val == '') && val == 0) {
    return '--'
  } else if (val == '30') {
    return '一个月'
  } else if (val == '60') {
    return '两个月'
  } else if (val == '90') {
    return '三个月'
  }
  return val;
}

export function filterTime(val) {
  if (val != null && val != '') {
    return val.split("T")[0]
  } else {
    return '--'
  }
}

export function filterSpaceTime(val) {
  if (val != null && val != '') {
    return val.split(" ")[0]
  } else {
    return '—'
  }
}

export function getTime(val) {
  if (val != null && val != '') {
    return val.split(" ")[0]
  } else {
    return '--'
  }
  return val;
}


export function effectiveTime(val) {
  if (val != null && val != '') {
    return val.split(" ")[0]
  } else {
    return '永久有效'
  }
  return val;
}

export function remainingTime(val) {
  var newDate = new Date()
  if (val != null && val != '') {
    if (Math.ceil((val.getTime() - newDate.getTime()) / (24 * 3600 * 1000)) < 11) {
      return '剩余' + Math.ceil((val.getTime() - newDate.getTime()) / (24 * 3600 * 1000)) + '天'
    } else {
      return ''
    }

  } else {
    return '—'
  }
  return val;
}
export function type(val) {
  var type = {
    Single: "单选题",
    Multiple: "多选题",
    Judge: "判断题",
    Fill: "填空题",
    Essay: "问答题",
    Material: "材料题",
  };
  for (var key in type) {
    if (key == val) {
      return type[key]
    } else if (val == type[key]) {
      return val
    }
  }
}
export function valLength(val, length) {
  if (val && val.length > length) {
    val = val.slice(0, length) + '...'
  } else if (val == null || val == '') {
    return '—'
  }
  return val
}

export function floor(num) {
  return Math.floor(num * 100)
}

export function timeFommater(value) {
  var dateee = new Date(value).toJSON();
  var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  return date;
}

//时长
export function formatFilter(value) {

  var secondTime = parseInt(value);// 秒
  var minuteTime = 0;// 分
  var hourTime = 0;// 小时
  if (secondTime > 59) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);

    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 59) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  if (secondTime < 10) {
    var result = "" + "0" + parseInt(secondTime);
  } else {
    var result = "" + parseInt(secondTime);
  }

  if (minuteTime > 0) {
    if (minuteTime < 10) {
      result = "0" + parseInt(minuteTime) + ":" + result;
    } else {
      result = "" + parseInt(minuteTime) + ":" + result;
    }
  } else {
    result = "00:" + result;
  }
  if (hourTime > 0) {
    if (hourTime < 10) {
      result = "0" + parseInt(hourTime) + ":" + result;
    } else {
      result = "" + parseInt(hourTime) + ":" + result;
    }
  }
  return result;
}

export function changeSize(val) {
  if (val > 1000000) {
    return (val / 1024 / 1024).toFixed(2) + 'M'
  } else {
    return (val / 1024).toFixed(2) + 'KB'
  }
}

export function getFileName(val) {
  if (val) {
    var data = val.split('/')
    val = data[data.length - 1]
    return val
  }
}

export function typeFile(val) {
  const type = [
    { name: "Platform", displayName: "平台" }, { name: "All", displayName: "全部" }, { name: "Domain", displayName: "管辖" }, { name: "Owner", displayName: "个人" }, { name: "Prohibited", displayName: "禁止" }
  ]

  type.map((item) => {
    if (item.name == val) {
      val = item.displayName
    }
  })
  return val
}

export function filterType(val, dic) {
  var text = "";
  dic.map((item) => {
    if (val == item.value) {
      text = item.text;
    }
  });
  return text;
}
export function filterValType(val, dic,type) {
  var text = "";
  if(type=='val'){
    for(var key in dic){
      if (val == dic[key]) {
        text = key;
      }
    }
}else{
  for(var key in dic){
    if (val.toLowerCase() == key.toLowerCase()) {
      text = dic[key];
    }
  }
}
  return text;
}

export function getEnumOptions(obj, name) {
	let arr=[];
	obj.map(el=>{
		if (el.name==name) {
			el.value.map(item=>{
				arr.push({
          name:item.option,
          value:item.option
        })
			})
		}
	})
	return arr;
}
export function getEnumLabelOptions(obj, name) {
	let arr=[];
	obj.map(el=>{
		if (el.name==name) {
			el.value.map(item=>{
				arr.push({
          label:item.option,
          value:item.option
        })
			})
		}
	})
	return arr;
}


export function numNull(num) {
	num = num?num:0
	return num;
}